<div style="display: flex; justify-content: center; align-items: center; height: 100%">
  <div class="lds-ellipsis">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
